/* ============================================================
   BEAT THE STORM — interaction & motion engine (WP tēma)
   Pārnests no prototipa assets/app.js. Progressive enhancement:
   viss saturs dzīvo HTML — nekas šeit nav vajadzīgs lapas lasīšanai
   (GEO/LLM-friendly). NAV pārnests: dev-only "tweaks" panelis un
   EDITMODE persistence (sk. wp-dev-handoff.md §7 "ko NE pārnest").
   Kritiskie gotchas a–h: wp-design-system-reference.md §4.
   ============================================================ */
(function () {
    "use strict";
    var _a;
    var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var root = document.documentElement;
    // .js karogs — reveal slēptais stāvoklis tikai zem .js (bez-JS saturs redzams)
    root.classList.remove("no-js");
    root.classList.add("js");
    // Motion skala (energy paliek no CSS :root noklusējuma 56; Theme Settings var pārrakstīt vēlāk)
    root.style.setProperty("--motion", prefersReduced ? "0" : "0.5");
    /* ---------- Header scroll state ------------------------------ */
    var header = document.querySelector(".site-header");
    function onScroll() {
        if (header)
            header.classList.toggle("is-scrolled", window.scrollY > 24);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    /* ---------- Reduced motion: stop background videos too ------- */
    if (prefersReduced) {
        document.querySelectorAll("video[autoplay]").forEach(function (v) {
            v.removeAttribute("autoplay");
            try {
                v.pause();
            }
            catch (e) { }
        });
    }
    /* ---------- Fona video: ielādē tikai tad, kad tuvojas ekrānam --- */
    // Fona video markup nāk BEZ avota (blocks/hero, blocks/storm-hero) — ar `autoplay`
    // pārlūks failu velk uzreiz un pilnībā, arī tad, ja tas ir lapas apakšā. Sākumlapā
    // hero bloks ir trīs reizes, un 2026-09-22 mērījums rādīja 21,2 MB video pie vienas
    // ielādes. Plakāts (poster) ir redzams uzreiz, tāpēc gaidīšana neko nemaina vizuāli.
    var bgVideos = document.querySelectorAll("video[data-bg-video]");
    if (bgVideos.length) {
        var loadBgVideo = function (v) {
            if (v.getAttribute("data-bg-loaded")) {
                return;
            }
            v.setAttribute("data-bg-loaded", "1");
            var source = document.createElement("source");
            source.src = v.getAttribute("data-bg-video");
            source.type = "video/mp4";
            v.appendChild(source);
            v.load();
            var played = v.play();
            // Ja pārlūks atskaņošanu atsaka (enerģijas taupīšana, politika), tā ir tikai
            // dekorācija — plakāts paliek, un kļūda konsolē nav vajadzīga.
            if (played && played.catch) {
                played.catch(function () { });
            }
        };
        if (prefersReduced) {
            // Kustību samazinošam lietotājam video nav vajadzīgs vispār — plakāts ir tas
            // pats kadrs, un fails netiek lejupielādēts.
            bgVideos.forEach(function (v) { v.removeAttribute("data-bg-video"); });
        }
        else if (!("IntersectionObserver" in window)) {
            bgVideos.forEach(loadBgVideo);
        }
        else {
            var bgObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        loadBgVideo(entry.target);
                        bgObserver.unobserve(entry.target);
                    }
                });
            }, { rootMargin: "200px 0px" });
            bgVideos.forEach(function (v) { bgObserver.observe(v); });
        }
    }
    /* ---------- Hero video pause control (WCAG 2.2.2) ------------ */
    var heroVideo = document.querySelector(".hero__video");
    if (heroVideo && heroVideo.closest(".hero")) {
        var SVG_NS = "http://www.w3.org/2000/svg";
        var makeIcon = function (d) {
            var svg = document.createElementNS(SVG_NS, "svg");
            svg.setAttribute("viewBox", "0 0 24 24");
            svg.setAttribute("fill", "currentColor");
            svg.setAttribute("aria-hidden", "true");
            var path = document.createElementNS(SVG_NS, "path");
            path.setAttribute("d", d);
            svg.appendChild(path);
            return svg;
        };
        var iconPause = makeIcon("M7 5h4v14H7zM13 5h4v14h-4z");
        var iconPlay = makeIcon("M8 5l11 7-11 7z");
        var vbtn = document.createElement("button");
        vbtn.className = "video-toggle";
        vbtn.type = "button";
        vbtn.appendChild(iconPlay);
        vbtn.appendChild(iconPause);
        var syncVideoBtn = function () {
            var paused = heroVideo.paused;
            iconPlay.style.display = paused ? "" : "none";
            iconPause.style.display = paused ? "none" : "";
            vbtn.setAttribute("aria-label", paused ? "Play background video" : "Pause background video");
        };
        vbtn.addEventListener("click", function () {
            if (heroVideo.paused) {
                heroVideo.play();
            }
            else {
                heroVideo.pause();
            }
        });
        heroVideo.addEventListener("play", syncVideoBtn);
        heroVideo.addEventListener("pause", syncVideoBtn);
        heroVideo.closest(".hero").appendChild(vbtn);
        syncVideoBtn();
    }
    /* ---------- Mobile nav --------------------------------------- */
    var burger = document.querySelector(".nav__burger");
    var drawer = document.querySelector(".mobile-nav");
    function closeDrawer() {
        if (drawer) {
            drawer.classList.remove("is-open");
            drawer.setAttribute("aria-hidden", "true");
            if (burger)
                burger.setAttribute("aria-expanded", "false");
            document.body.style.overflow = "";
        }
    }
    if (burger && drawer) {
        burger.addEventListener("click", function () {
            drawer.classList.add("is-open");
            drawer.setAttribute("aria-hidden", "false");
            burger.setAttribute("aria-expanded", "true");
            document.body.style.overflow = "hidden";
        });
        drawer.querySelectorAll("[data-close], a.m-link").forEach(function (el) {
            el.addEventListener("click", closeDrawer);
        });
        // C5/gotcha (f): izceļ pašreizējās lapas links; normalizē ceļu (produkcijā tīri URL)
        var normPath = function (p) {
            try {
                p = decodeURIComponent(p);
            }
            catch (e) { }
            return (p.replace(/\/index\.html?$/, "/").replace(/\.html?$/, "").replace(/\/+$/, "")) || "/";
        };
        var herePath = normPath(location.pathname);
        drawer.querySelectorAll("a[href]").forEach(function (a) {
            var href = a.getAttribute("href") || "";
            if (href.indexOf("#") !== -1)
                return;
            if (normPath(a.pathname) === herePath) {
                a.classList.add("is-current");
                a.setAttribute("aria-current", "page");
            }
        });
        // gotcha (b): pārsniedzot mobilo breakpoint — aizver drawer + atbloķē scroll
        window.matchMedia("(max-width: 860px)").addEventListener("change", function (e) {
            if (!e.matches && drawer.classList.contains("is-open"))
                closeDrawer();
        });
        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape")
                closeDrawer();
        });
    }
    /* ---------- C4: Turn-key roadmap "Read more" (mobile accordion) */
    document.querySelectorAll(".roadmap").forEach(function (rm) {
        var steps = rm.querySelectorAll(".roadmap__step");
        if (steps.length <= 3)
            return;
        var hidden = steps.length - 3;
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "roadmap__more";
        btn.setAttribute("aria-expanded", "false");
        var label = document.createElement("span");
        label.textContent = "Read more (" + hidden + ")";
        btn.appendChild(label);
        var svgNS = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("viewBox", "0 0 24 24");
        svg.setAttribute("fill", "none");
        svg.setAttribute("stroke", "currentColor");
        svg.setAttribute("stroke-width", "2");
        svg.setAttribute("aria-hidden", "true");
        var path = document.createElementNS(svgNS, "path");
        path.setAttribute("d", "M6 9l6 6 6-6");
        svg.appendChild(path);
        btn.appendChild(svg);
        rm.insertAdjacentElement("afterend", btn);
        btn.addEventListener("click", function () {
            var open = rm.classList.toggle("is-expanded");
            btn.setAttribute("aria-expanded", open ? "true" : "false");
            label.textContent = open ? "Show less" : "Read more (" + hidden + ")";
        });
    });
    /* ---------- Client wall: text fallback if a logo fails ------- */
    document.querySelectorAll(".client-logo img").forEach(function (img) {
        var toName = function () {
            var a = img.closest(".client-logo");
            if (!a)
                return;
            if (a.querySelector(".client-logo__name")) {
                img.remove();
                return;
            }
            var span = document.createElement("span");
            span.className = "client-logo__name";
            span.textContent = a.getAttribute("data-name") || img.alt || "";
            img.replaceWith(span);
        };
        img.addEventListener("error", toName);
        if (img.complete && img.naturalWidth === 0)
            toName();
    });
    /* ---------- Reveal on scroll --------------------------------- */
    var reveals = document.querySelectorAll(".reveal");
    if (reveals.length) {
        if (prefersReduced || !("IntersectionObserver" in window)) {
            reveals.forEach(function (el) { el.classList.add("is-in"); });
        }
        else {
            var ro = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                    if (e.isIntersecting) {
                        e.target.classList.add("is-in");
                        ro.unobserve(e.target);
                    }
                });
            }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
            reveals.forEach(function (el) { ro.observe(el); });
        }
    }
    /* ---------- Count-up stats ----------------------------------- */
    function formatNum(n, decimals) {
        if (decimals)
            return n.toFixed(decimals);
        return Math.round(n).toLocaleString("en-US");
    }
    function countUp(el) {
        var target = parseFloat(el.getAttribute("data-count"));
        var decimals = parseInt(el.getAttribute("data-decimals") || "0", 10);
        var prefix = el.getAttribute("data-prefix") || "";
        var suffix = el.getAttribute("data-suffix") || "";
        if (prefersReduced) {
            el.textContent = prefix + formatNum(target, decimals) + suffix;
            return;
        }
        var dur = 1500, start = null;
        function step(ts) {
            if (!start)
                start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = prefix + formatNum(target * eased, decimals) + suffix;
            if (p < 1)
                requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }
    var counters = document.querySelectorAll("[data-count]");
    if (counters.length) {
        if (!("IntersectionObserver" in window)) {
            counters.forEach(countUp);
        }
        else {
            var co = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) { if (e.isIntersecting) {
                    countUp(e.target);
                    co.unobserve(e.target);
                } });
            }, { threshold: 0.5 });
            counters.forEach(function (el) { co.observe(el); });
        }
    }
    /* ---------- Video modal (MP4 vai YouTube nocookie) ------------- */
    /* Katrai pogai SAVS modālis pēc data-video-open="<dialog id>". Lapā var būt
       vairāki (hero + video-grid), un hero modālis var būt YouTube iframe, kamēr
       video-grid kartes ir MP4 — viens kopīgs modālis tos sajauktu. Tukša vērtība
       = pirmais .video-modal (atpakaļsaderība ar vecākiem paraugiem). */
    document.querySelectorAll("[data-video-open]").forEach(function (btn) {
        var ref = btn.getAttribute("data-video-open") || "";
        var modal = ref ? document.getElementById(ref) : document.querySelector(".video-modal");
        if (!modal || typeof modal.showModal !== "function")
            return;
        if (!modal.hasAttribute("data-vm-bound")) {
            modal.setAttribute("data-vm-bound", "");
            /* Apturēšana ir IDEMPOTENTA un tiek saukta no VISIEM aizvēršanas ceļiem:
               poga, klikšķis uz fona, ESC. Paļauties tikai uz "close" notikumu
               nepietiek — daļa WebKit dzinēju to programmatiskam close() nesūta, un
               tad video (vai YouTube) turpina skanēt aiz aizvērta modāļa. */
            var vmStop = function () {
                var v = modal.querySelector("video");
                var f = modal.querySelector("iframe[data-yt-src]");
                if (v)
                    v.pause();
                /* about:blank aptur YouTube atskaņošanu; src atribūta noņemšana atjauno
                   "vēl nav ielādēts" stāvokli — src="" to nedarītu, jo, lasot atpakaļ,
                   tas atrisinās uz lapas adresi un nākamā atvēršana video nesāktu. */
                if (f && f.getAttribute("src")) {
                    f.src = "about:blank";
                    f.removeAttribute("src");
                }
            };
            var vmDismiss = function () { modal.close(); vmStop(); };
            var vmClose = modal.querySelector(".video-modal__close");
            if (vmClose)
                vmClose.addEventListener("click", vmDismiss);
            modal.addEventListener("click", function (e) { if (e.target === modal)
                vmDismiss(); });
            modal.addEventListener("close", vmStop);
            modal.addEventListener("cancel", vmStop); // ESC (dzinēji ar native cancel)
            /* Skaidrs ESC — daļa dzinēju <dialog> vispār neaizver ar ESC. Tur, kur
               native cancel strādā, preventDefault to nomaina pret to pašu rezultātu.
               Ja fokuss ir YouTube iframe iekšpusē, taustiņš pie mums nenonāk — tas ir
               cross-origin ierobežojums jebkurā pārlūkā. */
            modal.addEventListener("keydown", function (e) {
                if (e.key === "Escape") {
                    e.preventDefault();
                    vmDismiss();
                }
            });
        }
        btn.addEventListener("click", function () {
            var vmVideo = modal.querySelector("video");
            var vmFrame = modal.querySelector("iframe[data-yt-src]");
            // Ja pogai savs video (video-grid karte) — nomaina modal avotu pirms atvēršanas.
            var perCard = btn.getAttribute("data-video-src");
            var perCardYt = btn.getAttribute("data-yt-src");
            /* Video-grid kartes var būt JAUKTAS (daļa MP4, daļa YouTube), bet modālis blokam
               ir viens, tāpēc pārslēdzam pēc kartes. Bez tā YouTube karte atskaņotu tukšu
               <video>. Hero pogām šo atribūtu nav (hero renderē tikai vienu elementu), tāpēc
               abi zari tiek izlaisti un hero uzvedība nemainās. */
            if (perCardYt && vmFrame) {
                if (vmFrame.getAttribute("data-yt-src") !== perCardYt) {
                    if (vmFrame.getAttribute("src")) {
                        vmFrame.src = "about:blank";
                        vmFrame.removeAttribute("src");
                    }
                    vmFrame.setAttribute("data-yt-src", perCardYt);
                }
                if (vmVideo) {
                    vmVideo.pause();
                    vmVideo.hidden = true;
                }
                vmFrame.hidden = false;
            }
            else if (perCard && vmVideo) {
                var s = vmVideo.querySelector("source");
                if (s && s.getAttribute("src") !== perCard) {
                    s.setAttribute("src", perCard);
                    vmVideo.load();
                }
                if (vmFrame) {
                    if (vmFrame.getAttribute("src")) {
                        vmFrame.src = "about:blank";
                        vmFrame.removeAttribute("src");
                    }
                    vmFrame.hidden = true;
                }
                vmVideo.hidden = false;
            }
            modal.showModal();
            /* video_play — GTM no tā palaiž GA4 notikumu (IAAPA landing mērījumi, bet der
               visai vietnei). Nosaukums no modāļa aria-label vai pogas teksta. */
            var dl = window;
            dl.dataLayer = dl.dataLayer || [];
            dl.dataLayer.push({ event: "video_play", video_title: modal.getAttribute("aria-label") || (btn.textContent || "").trim() });
            if (vmVideo && !vmVideo.hidden) {
                try {
                    vmVideo.currentTime = 0;
                    var pp = vmVideo.play();
                    if (pp && pp.catch)
                        pp.catch(function () { });
                }
                catch (e) { }
            }
            // Lazy YouTube — src tiek uzstādīts tikai uz lietotāja klikšķi (autoplay + sīkdatnes).
            if (vmFrame && !vmFrame.hidden && !vmFrame.getAttribute("src")) {
                vmFrame.setAttribute("src", vmFrame.getAttribute("data-yt-src") || "");
            }
        });
    });
    /* ---------- A7: video gallery filter by wind speed ---------- */
    document.querySelectorAll(".media-filter").forEach(function (row) {
        var block = row.closest(".block-video-grid");
        var grid = (block && block.querySelector(".video-grid")) || document.querySelector(".video-grid");
        if (!grid)
            return;
        var chips = row.querySelectorAll(".filter-chip");
        chips.forEach(function (chip) {
            chip.addEventListener("click", function () {
                var f = chip.getAttribute("data-vfilter");
                chips.forEach(function (c) {
                    var on = c === chip;
                    c.classList.toggle("is-active", on);
                    c.setAttribute("aria-pressed", on ? "true" : "false");
                });
                grid.querySelectorAll(".video-card").forEach(function (card) {
                    card.hidden = !(f === "all" || card.getAttribute("data-speed") === f);
                });
            });
        });
    });
    /* ---------- #contact CTA → smooth-scroll uz kontaktu sekciju -- */
    // Izšķir ŠĪ lapa, ne saites ceļš: galvenes "Book a call" (un footera saites) nāk no
    // Theme Settings ar pilnu adresi uz sākumlapu, tāpēc uz landing lapas, kurai PAŠAI ir
    // kontaktu forma, klikšķis aizmeta uz sākumlapu — lietotājs pazaudēja lapu, kurā jau
    // bija. Tāpēc: ja šajā lapā kontaktu sekcija ir, ritinām pie tās; ja nav — ejam pa
    // saiti uz to lapu, kur forma ir (piem. Insights raksti, kuriem sekcijas nav).
    // Visā vietnē #contact saites ved vai nu uz šo lapu, vai uz sākumlapu — nevienas,
    // kas ar nolūku sūtītu uz KONKRĒTAS citas lapas formu, tāpēc šis nepārtver nevienu
    // apzinātu pāreju.
    document.querySelectorAll('a[href$="#contact"]').forEach(function (a) {
        a.addEventListener("click", function (e) {
            var target = document.getElementById("contact");
            if (!target)
                return; // šai lapai formas nav → normāla navigācija
            e.preventDefault();
            var y = target.getBoundingClientRect().top + window.pageYOffset - 72;
            window.scrollTo({ top: y, behavior: prefersReduced ? "auto" : "smooth" });
            // Mobilajā šī saite dzīvo arī burger izvēlnē. Tās punktiem ir data-close, tāpēc
            // drawer aizveras jau ar savu klausītāju, bet šis izsaukums ir drošības josta:
            // ja atvērts drawer paliktu, body.overflow = "hidden" neļautu ritināt.
            closeDrawer();
        });
    });
    /* ---------- Landing: mobilā poga ekrāna apakšā --------------- */
    // Paslēpjas, kamēr pieraksta sadaļa ir redzama: citādi tā aizsegtu kalendāra
    // apakšu tieši tajā brīdī, kad cilvēks izvēlas laiku, un dublētu to, ko viņš jau
    // redz. Bez IntersectionObserver poga vienkārši paliek redzama.
    var landingSticky = document.querySelector("[data-landing-sticky]");
    if (landingSticky && "IntersectionObserver" in window) {
        var landingHref = ((_a = landingSticky.querySelector("a")) === null || _a === void 0 ? void 0 : _a.getAttribute("href")) || "";
        var landingTarget = landingHref.charAt(0) === "#" ? document.getElementById(landingHref.slice(1)) : null;
        if (landingTarget) {
            new IntersectionObserver(function (es) {
                landingSticky.classList.toggle("is-hidden", es[0].isIntersecting);
            }, { threshold: 0.05 }).observe(landingTarget);
        }
    }
    /* ---------- FAQ accordion ------------------------------------ */
    document.querySelectorAll(".faq-q").forEach(function (q) {
        q.addEventListener("click", function () {
            var item = q.closest(".faq-item");
            var ans = item.querySelector(".faq-a");
            var open = item.classList.toggle("is-open");
            q.setAttribute("aria-expanded", String(open));
            ans.style.maxHeight = open ? ans.scrollHeight + "px" : "0";
        });
    });
    /* ---------- Forms: simulated success (WP → CF7 aizstās) ------ */
    document.querySelectorAll("form[data-sim]").forEach(function (form) {
        form.addEventListener("submit", function (e) {
            e.preventDefault();
            var btn = form.querySelector("[type=submit]");
            if (btn) {
                btn.disabled = true;
                btn.dataset.label = btn.textContent;
                btn.textContent = "Sending…";
            }
            setTimeout(function () {
                form.classList.add("is-sent");
                if (btn) {
                    btn.disabled = false;
                    btn.textContent = btn.dataset.label;
                }
            }, prefersReduced ? 120 : 700);
        });
    });
    /* ---------- Insights filter --------------------------------- */
    var filterRow = document.querySelector(".filter-row");
    if (filterRow) {
        var posts = document.querySelectorAll("#posts .post-card");
        var noRes = document.getElementById("no-results");
        filterRow.querySelectorAll(".filter-chip").forEach(function (chip) {
            chip.addEventListener("click", function () {
                var f = chip.getAttribute("data-filter");
                filterRow.querySelectorAll(".filter-chip").forEach(function (c) {
                    var on = c === chip;
                    c.classList.toggle("is-active", on);
                    c.setAttribute("aria-pressed", on ? "true" : "false");
                });
                var shown = 0;
                posts.forEach(function (p) {
                    var on = f === "all" || p.getAttribute("data-cat") === f;
                    p.hidden = !on;
                    if (on)
                        shown++;
                });
                if (noRes)
                    noRes.hidden = shown !== 0;
            });
        });
    }
    /* ---------- Contact: swappable form by tier ----------------- */
    document.querySelectorAll("[data-form-card]").forEach(function (card) {
        // Tier pogas un forma ir vienā .split — meklējam tikai tur, lai divi contact
        // bloki vienā lapā nepārslēgtu viens otra formu un nereģistrētu klausītājus
        // divreiz uz tām pašām pogām.
        var scope = card.closest(".split") || card.parentElement || document;
        var tierButtons = function () { return Array.prototype.slice.call(scope.querySelectorAll("[data-form]")); };
        var form = card.querySelector(".form");
        var title = card.querySelector("[data-form-title]");
        var sub = card.querySelector("[data-form-sub]");
        var submit = card.querySelector("[data-submit]");
        var sTitle = card.querySelector("[data-success-title]");
        var sSub = card.querySelector("[data-success-sub]");
        var meta = {
            call: { title: "Book a diagnostic call", sub: "Short form — just the essentials. We cover footprint & power on the call.", submit: "Send enquiry", sTitle: "Enquiry sent", sSub: "Thanks — we'll be in touch within one business day to schedule your call." },
            briefing: { title: "Get the Monthly Briefing", sub: "One email a month — ROI and credibility data. Unsubscribe anytime.", submit: "Subscribe", sTitle: "You're subscribed", sSub: "Thanks — your first Monthly Briefing is on its way." },
            onepager: { title: "Get the ROI one-pager", sub: "A shareable PDF summary for the decision-makers behind you.", submit: "Email me the one-pager", sTitle: "On its way", sSub: "Thanks — check your inbox for the ROI one-pager." }
        };
        function select(key) {
            // Derīgs tikai, ja šai atslēgai ir fset — CMS var lietot jebkuru form_key, ne tikai meta.
            if (!form)
                return;
            var targetFset = form.querySelector('.fset[data-set="' + key + '"]');
            if (!targetFset)
                return;
            var tBtn = scope.querySelector('[data-form="' + key + '"]');
            var m = meta[key] || {};
            form.classList.remove("is-sent");
            form.querySelectorAll(".fset").forEach(function (f) {
                var on = f.getAttribute("data-set") === key;
                f.classList.toggle("is-active", on);
                f.querySelectorAll("input,select,textarea").forEach(function (el) {
                    // NEATSPĒJOT CF7 slēptos control laukus (_wpcf7*) — citādi CF7 6.x init sabrūk (NaN schema) → forma iestrēgst submit.
                    if (el.type === "hidden" || (el.name && el.name.charAt(0) === "_"))
                        return;
                    el.disabled = !on;
                });
            });
            // Datu-vadīts: virsraksts/apakšteksts no tier pogas (CMS); fallback uz meta.
            var newTitle = (tBtn && tBtn.getAttribute("data-form-title")) || m.title;
            var newSub = (tBtn && tBtn.getAttribute("data-form-sub")) || m.sub;
            if (title && newTitle)
                title.textContent = newTitle;
            if (sub && newSub)
                sub.textContent = newSub;
            if (submit && m.submit)
                submit.textContent = m.submit;
            if (sTitle && m.sTitle)
                sTitle.textContent = m.sTitle;
            if (sSub && m.sSub)
                sSub.textContent = m.sSub;
            tierButtons().forEach(function (t) {
                var on = t.getAttribute("data-form") === key;
                t.classList.toggle("is-selected", on);
                t.setAttribute("aria-pressed", on ? "true" : "false");
            });
        }
        var formMobile = function () { return window.matchMedia("(max-width: 860px)").matches; };
        /* Tier izvēle mobilajā: ritinām pie formas.
           Šeit bija prototipa bottom-sheet (`is-sheet` + `body.overflow = hidden`
           + ievietots backdrop ar aizvēršanu). Tēmā tam CSS NAV — `[data-form-card]`
           palika `position: static` zem tier kartēm, backdrop bez `position`/`z-index`
           bija neredzams un neuzspiežams, bet body ritināšana palika bloķēta: lapa
           nosala līdz pārlādei (atrasts uz staging, iOS Safari).
    
           Neatjaunoju sheet CSS ar nolūku: tēmā forma mobilajā ir redzama inline
           (prototipā to slēpa `[data-form-card] { display: none }`), tāpēc pietiek ar
           to, lai pieskāriens aizvestu pie formas — nav vajadzīgs ne fixed slānis, ne
           scroll lock, ne aizvēršanas žests. */
        function revealForm() {
            if (!form)
                return;
            var target = function () { return card.getBoundingClientRect().top + window.pageYOffset - 84; };
            window.scrollTo({ top: target(), behavior: prefersReduced ? "auto" : "smooth" });
            // Mērķi aprēķina pieskāriena brīdī, bet lēni ielādētie attēli AUGSTĀK lapā
            // var karti pabīdīt, kamēr ritinājums vēl notiek (Home mobilajā virs formas
            // ir 19 lazy attēli, 7 bez width/height) — izmērīts staging: lapa paauga
            // ~3000px un forma nosēdās ārpus ekrāna. Tāpēc pēc nosēšanās pārbaudām
            // vienu reizi un pielabojam, ja lietotājs tikmēr nav sācis ritināt pats.
            var touched = false;
            var mark = function () { touched = true; };
            ["wheel", "touchstart", "keydown"].forEach(function (ev) {
                window.addEventListener(ev, mark, { once: true, passive: true });
            });
            setTimeout(function () {
                ["wheel", "touchstart", "keydown"].forEach(function (ev) { window.removeEventListener(ev, mark); });
                if (touched)
                    return;
                var off = card.getBoundingClientRect().top - 84;
                if (Math.abs(off) > 40) {
                    window.scrollTo({ top: window.pageYOffset + off, behavior: "auto" });
                }
            }, 800);
        }
        tierButtons().forEach(function (t) {
            t.addEventListener("click", function () {
                select(t.getAttribute("data-form") || "call");
                if (formMobile())
                    revealForm();
            });
        });
        function openBriefing() {
            select("briefing");
            if (formMobile()) {
                revealForm();
                return;
            }
            var sec = document.getElementById("contact");
            if (sec) {
                window.scrollTo({ top: sec.getBoundingClientRect().top + window.pageYOffset - 72, behavior: prefersReduced ? "auto" : "smooth" });
            }
        }
        document.querySelectorAll('a[href$="#briefing"]').forEach(function (a) {
            a.addEventListener("click", function (e) {
                var href = a.getAttribute("href");
                if (href.charAt(0) !== "#" && a.pathname !== location.pathname)
                    return;
                e.preventDefault();
                openBriefing();
            });
        });
        select("call");
        if (location.hash === "#briefing")
            openBriefing();
    });
    /* ---------- Gallery: lightbox (desktop) / swipe-only (mobile) --- */
    var galleries = document.querySelectorAll(".gallery");
    if (galleries.length) {
        var glDesktop = function () { return window.matchMedia("(min-width: 861px)").matches; };
        var gl = null, glImg, glCount, glItems = [], glIdx = 0;
        var glSvg = function (d) {
            var ns = "http://www.w3.org/2000/svg";
            var s = document.createElementNS(ns, "svg");
            s.setAttribute("viewBox", "0 0 24 24");
            s.setAttribute("fill", "none");
            s.setAttribute("stroke", "currentColor");
            s.setAttribute("stroke-width", "2");
            s.setAttribute("aria-hidden", "true");
            var p = document.createElementNS(ns, "path");
            p.setAttribute("d", d);
            s.appendChild(p);
            return s;
        };
        var glBtn = function (cls, label, d, fn) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = "lightbox__btn " + cls;
            b.setAttribute("aria-label", label);
            b.appendChild(glSvg(d));
            b.addEventListener("click", fn);
            return b;
        };
        /* Pilnizmēra avots gaismas kastei. NEDRĪKST ņemt currentSrc — tas ir režģa
           flīzei izvēlētais srcset kandidāts (sīktēls), un pa visu ekrānu tas ir
           izplūdis. Kamēr galerijai nebija srcset, currentSrc sakrita ar src; tagad
           jāņem platākais kandidāts, ar src kā rezervi. */
        var glFullSrc = function (el) {
            var best = el.getAttribute("src") || el.src || "";
            var ss = el.getAttribute("srcset");
            if (ss) {
                var w = -1;
                ss.split(",").forEach(function (part) {
                    var m = part.trim().match(/^(\S+)\s+(\d+)w$/);
                    if (m && +m[2] > w) {
                        w = +m[2];
                        best = m[1];
                    }
                });
            }
            return best;
        };
        var glRender = function () {
            var it = glItems[glIdx];
            glImg.src = it.src;
            glImg.alt = it.alt;
            glCount.textContent = (glIdx + 1) + " / " + glItems.length;
            /* Ar vienu attēlu bultas un skaitītājs ir vadīklas bez darba. */
            gl.classList.toggle("lightbox--single", glItems.length < 2);
        };
        var glGo = function (n) { glIdx = (glIdx + n + glItems.length) % glItems.length; glRender(); };
        var glClose = function () { if (gl.open)
            gl.close(); };
        var glBuild = function () {
            gl = document.createElement("dialog");
            gl.className = "lightbox";
            gl.setAttribute("aria-label", "Gallery");
            var frame = document.createElement("div");
            frame.className = "lightbox__frame";
            glImg = document.createElement("img");
            glImg.className = "lightbox__media";
            frame.appendChild(glImg);
            glCount = document.createElement("div");
            glCount.className = "lightbox__count";
            gl.appendChild(frame);
            gl.appendChild(glBtn("lightbox__close", "Close", "M6 6l12 12M18 6L6 18", glClose));
            gl.appendChild(glBtn("lightbox__prev", "Previous image", "M15 18l-6-6 6-6", function () { glGo(-1); }));
            gl.appendChild(glBtn("lightbox__next", "Next image", "M9 18l6-6-6-6", function () { glGo(1); }));
            gl.appendChild(glCount);
            document.body.appendChild(gl);
            gl.addEventListener("click", function (e) { if (e.target === gl || e.target === frame)
                glClose(); });
            document.addEventListener("keydown", function (e) {
                if (!gl.open)
                    return;
                if (e.key === "ArrowLeft")
                    glGo(-1);
                else if (e.key === "ArrowRight")
                    glGo(1);
            });
        };
        galleries.forEach(function (g) {
            var imgs = g.querySelectorAll("img");
            imgs.forEach(function (img, i) {
                img.addEventListener("click", function () {
                    if (!glDesktop())
                        return; // mobilajā tikai swipe, bez popup
                    if (!gl)
                        glBuild();
                    glItems = [].map.call(imgs, function (el) { return { src: glFullSrc(el), alt: el.alt || "" }; });
                    glIdx = i;
                    glRender();
                    gl.showModal();
                });
            });
        });
    }
    /* ---------- ROI calculator ----------------------------------- */
    var roi = document.querySelector("[data-roi]");
    if (roi) {
        var inputs = roi.querySelectorAll("input[type=range]");
        var cfg = {};
        try {
            cfg = JSON.parse(roi.getAttribute("data-roi-config") || "{}");
        }
        catch (e) {
            cfg = {};
        }
        var cur = (cfg && typeof cfg.currency === "string" && cfg.currency) ? cfg.currency : "€";
        var cfgCosts = (cfg && Array.isArray(cfg.costs) && cfg.costs.length) ? cfg.costs : [
            { amount: 0.16, basis: "per_rider" },
            { amount: 38000, basis: "per_year" },
            { amount: 9000, basis: "per_year" }
        ];
        var fmtEUR = function (n) {
            if (Math.abs(n) >= 1000000)
                return cur + (n / 1000000).toFixed(2) + "M";
            return cur + Math.round(n).toLocaleString("en-US");
        };
        function calc() {
            var v = {};
            inputs.forEach(function (i) { v[i.name] = parseFloat(i.value); });
            inputs.forEach(function (i) {
                var out = roi.querySelector('[data-out="' + i.name + '"]');
                if (!out)
                    return;
                if (i.name === "price")
                    out.textContent = cur + v.price;
                else if (i.name === "invest")
                    out.textContent = fmtEUR(v.invest);
                else
                    out.textContent = Math.round(v[i.name]).toLocaleString("en-US");
            });
            var grossRevenue = v.price * v.riders * v.days;
            /* Izmaksu pozīcijas nāk no Theme Settings caur data-roi-config (sk.
               storm_roi_config()). Rezerve zemāk ir vēsturiskās konstantes, lai
               kalkulators strādā arī tad, ja atribūta nav vai tas ir bojāts. */
            var perRider = 0, perYear = 0;
            cfgCosts.forEach(function (c) {
                var amt = parseFloat(c && c.amount) || 0;
                if (c && c.basis === "per_rider")
                    perRider += amt;
                else
                    perYear += amt;
            });
            var energy = perRider * v.riders * v.days;
            var opex = energy + perYear;
            var net = grossRevenue - opex;
            var payback = net > 0 ? v.invest / net : 0;
            var bigEl = roi.querySelector("[data-roi-payback]");
            var netEl = roi.querySelector("[data-roi-net]");
            var revEl = roi.querySelector("[data-roi-rev]");
            var opexEl = roi.querySelector("[data-roi-opex]");
            var enEl = roi.querySelector("[data-roi-energy]");
            if (bigEl)
                bigEl.textContent = payback > 0 ? payback.toFixed(1) : "—";
            if (netEl)
                netEl.textContent = fmtEUR(net);
            if (revEl)
                revEl.textContent = fmtEUR(grossRevenue);
            if (opexEl)
                opexEl.textContent = fmtEUR(opex);
            if (enEl)
                enEl.textContent = fmtEUR(energy);
            inputs.forEach(function (i) {
                var pct = (i.value - i.min) / (i.max - i.min) * 100;
                i.style.background = "linear-gradient(90deg, var(--ember-500) " + pct + "%, var(--track-fill, rgba(255,255,255,0.12)) " + pct + "%)";
            });
        }
        inputs.forEach(function (i) { i.addEventListener("input", calc); });
        calc();
    }
    /* ---------- Wind particle canvas (hero, desktop-only) -------- */
    var canvas = document.querySelector(".hero__canvas");
    if (canvas && !prefersReduced && window.matchMedia("(min-width: 861px)").matches) {
        var ctx = canvas.getContext("2d");
        var hero = canvas.closest(".hero");
        var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
        var particles = [];
        var mouse = { x: -9999, y: -9999, active: false };
        var running = false, raf = null;
        var cssEnergy = 56, cssMotion = 0.5, frameN = 0;
        var readCss = function () {
            var cs = getComputedStyle(root);
            cssEnergy = parseFloat(cs.getPropertyValue("--energy")) || 56;
            cssMotion = parseFloat(cs.getPropertyValue("--motion")) || 0.5;
        };
        var seed = function () {
            var count = Math.round(Math.min(W, 1400) / 14);
            particles = [];
            for (var i = 0; i < count; i++) {
                particles.push({
                    x: Math.random() * W,
                    y: Math.random() * H,
                    len: 40 + Math.random() * 130,
                    speed: 1.4 + Math.random() * 3.6,
                    w: Math.random() < 0.18 ? 1.5 : 0.7,
                    a: 0.04 + Math.random() * 0.16
                });
            }
        };
        var resize = function () {
            W = hero.clientWidth;
            H = hero.clientHeight;
            canvas.width = W * dpr;
            canvas.height = H * dpr;
            canvas.style.width = W + "px";
            canvas.style.height = H + "px";
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            seed();
        };
        var tick = function () {
            if ((frameN++ % 30) === 0)
                readCss();
            ctx.clearRect(0, 0, W, H);
            var energy = cssEnergy, motion = cssMotion;
            var gust = 0.6 + (energy / 100) * 1.4;
            for (var i = 0; i < particles.length; i++) {
                var p = particles[i];
                p.x += p.speed * gust * (0.4 + motion);
                if (mouse.active) {
                    var dx = p.x - mouse.x, dy = p.y - mouse.y;
                    var d2 = dx * dx + dy * dy;
                    if (d2 < 26000) {
                        var fct = (26000 - d2) / 26000;
                        p.y += (dy > 0 ? 1 : -1) * fct * 2.2;
                        p.x += fct * 1.5;
                    }
                }
                if (p.x - p.len > W) {
                    p.x = -p.len;
                    p.y = Math.random() * H;
                }
                var hot = energy / 100;
                var r = Math.round(120 + hot * 135), g = Math.round(200 - hot * 80), b = Math.round(225 - hot * 195);
                ctx.strokeStyle = "rgba(" + r + "," + g + "," + b + "," + p.a + ")";
                ctx.lineWidth = p.w;
                ctx.beginPath();
                ctx.moveTo(p.x, p.y);
                ctx.lineTo(p.x - p.len, p.y);
                ctx.stroke();
            }
            raf = requestAnimationFrame(tick);
        };
        var start = function () { if (!running) {
            running = true;
            tick();
        } };
        var stop = function () { running = false; if (raf)
            cancelAnimationFrame(raf); };
        hero.addEventListener("pointermove", function (e) {
            var rect = hero.getBoundingClientRect();
            mouse.x = e.clientX - rect.left;
            mouse.y = e.clientY - rect.top;
            mouse.active = true;
        });
        hero.addEventListener("pointerleave", function () { mouse.active = false; });
        window.addEventListener("resize", resize);
        resize();
        if ("IntersectionObserver" in window) {
            new IntersectionObserver(function (entries) {
                entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
            }, { threshold: 0.02 }).observe(hero);
        }
        else {
            start();
        }
    }
    /* ---------- Scroll-driven wind parallax (desktop) ----------- */
    var parallax = document.querySelectorAll("[data-parallax]");
    if (parallax.length && !prefersReduced) {
        var ticking = false;
        var onP = function () {
            parallax.forEach(function (el) {
                var speed = parseFloat(el.getAttribute("data-parallax")) || 0.1;
                var rect = el.getBoundingClientRect();
                var off = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed;
                el.style.transform = "translate3d(" + (-off) + "px,0,0)";
            });
            ticking = false;
        };
        window.addEventListener("scroll", function () {
            if (!ticking) {
                requestAnimationFrame(onP);
                ticking = true;
            }
        }, { passive: true });
        onP();
    }
    /* ============================================================
       ACCENT MOTION — 02 isobars · 04 gust wipe · 05 blown-in · 10 stagger
       Ports no design_handoff_accent_motion. Eksperiments (branch akcenta-animacijas).
       ============================================================ */
    (function accentMotion() {
        var hasIO = "IntersectionObserver" in window;
        function motionVal() { return prefersReduced ? 0 : (parseFloat(getComputedStyle(root).getPropertyValue("--motion")) || 0.5); }
        var inView = hasIO ? new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) {
                e.target.classList.add("is-in");
                inView.unobserve(e.target);
            } });
        }, { threshold: 0.4 }) : null;
        function observe(el) { if (inView)
            inView.observe(el);
        else
            el.classList.add("is-in"); }
        // Cikliskais triggeris: re-fire .is-in ar garu, randomizētu intervālu — TIKAI kamēr skatā.
        // Atturīgs, ne biežs (klienta izvēle). Reduced-motion / bez-IO → tikai gala stāvoklis.
        function loopTrigger(el, minMs, maxMs) {
            if (!hasIO || prefersReduced) {
                el.classList.add("is-in");
                return;
            }
            var timer = null, isIn = false;
            function refire() { el.classList.remove("is-in"); void el.offsetWidth; el.classList.add("is-in"); }
            function schedule() {
                if (timer)
                    clearTimeout(timer);
                timer = setTimeout(function () { if (isIn) {
                    refire();
                    schedule();
                } }, minMs + Math.random() * (maxMs - minMs));
            }
            var lio = new IntersectionObserver(function (es) {
                es.forEach(function (e) {
                    isIn = e.isIntersecting;
                    if (isIn) {
                        el.classList.add("is-in");
                        schedule();
                    }
                    else if (timer) {
                        clearTimeout(timer);
                        timer = null;
                    }
                });
            }, { threshold: 0.4 });
            lio.observe(el);
        }
        /* ---- 05 · Blown-in ---- */
        var heroHead = document.querySelector(".storm-hero__title, .hero .h-hero, .hero h1");
        /* Hero ar atklāšanu ritinot (.hero--reveal) blown-in NEDABŪ: abas mehānikas
           vada to pašu virsraksta necaurspīdīgumu, un animācija ar `forwards` kaskādē
           pārspēj `opacity: var(--r)`, tāpēc virsraksts paliktu redzams uzreiz. */
        if (heroHead && !heroHead.closest(".hero--reveal")) {
            heroHead.classList.add("blown-hero");
            heroHead.classList.add("is-in"); // hero fires on load
        }
        document.querySelectorAll(".section.surface-light .sec-head h2, .section.surface-airy .sec-head h2").forEach(function (h) {
            splitWords(h);
            observe(h); // blown = fire-once (ne cikliski — atturīgi)
        });
        function splitWords(h) {
            if (h.getAttribute("data-blown") === "1")
                return;
            h.setAttribute("data-blown", "1");
            h.classList.add("blown");
            var i = 0;
            var nodes = Array.prototype.slice.call(h.childNodes);
            h.textContent = "";
            nodes.forEach(function (node) {
                if (node.nodeType === 3) {
                    node.textContent.split(/(\s+)/).forEach(function (w) {
                        if (w === "")
                            return;
                        if (!w.trim()) {
                            h.appendChild(document.createTextNode(w));
                            return;
                        }
                        var s = document.createElement("span");
                        s.className = "blown-w";
                        s.style.setProperty("--i", String(i++));
                        s.textContent = w;
                        h.appendChild(s);
                    });
                }
                else if (node.nodeName === "BR") {
                    h.appendChild(node);
                }
                else {
                    node.classList.add("blown-w");
                    node.style.setProperty("--i", String(i++));
                    h.appendChild(node);
                }
            });
        }
        /* ---- 04 · Gust wipe (section-head uz dark/deep virsmas) ---- */
        var darkHeads = document.querySelectorAll(".block-section-head.surface-dark, .block-section-head.surface-deep");
        darkHeads.forEach(function (sec, idx) {
            if (sec.querySelector(".gust"))
                return;
            sec.classList.add("gust-host");
            var gust = document.createElement("div");
            gust.className = "gust";
            gust.setAttribute("aria-hidden", "true");
            for (var g = 0; g < 3; g++)
                gust.appendChild(document.createElement("i"));
            sec.insertBefore(gust, sec.firstChild);
            // Pirmā tumšā = lightning moment (streaks + flash) → cikliski; pārējām streaks fire-once.
            if (idx === 0)
                loopTrigger(sec, 5000, 10000);
            else
                observe(sec);
        });
        /* ---- 14 · Flash-lit H2 (VIENS uz lapu — pirmā tumšā section-head; rides sekcijas .is-in loop) ---- */
        var flashSec = darkHeads[0];
        if (flashSec) {
            var fHead = flashSec.querySelector("h1, h2, h3");
            if (fHead && !fHead.closest(".flashlit-wrap")) {
                var fLabel = fHead.closest(".hub-sec-label, .sec-head");
                if (fLabel)
                    fLabel.classList.remove("reveal"); // flash aizstāj reveal uz virsraksta
                var fwrap = document.createElement("div");
                fwrap.className = "flashlit-wrap";
                fHead.parentNode.insertBefore(fwrap, fHead);
                fwrap.appendChild(fHead);
                fHead.classList.add("flashlit");
                if (!flashSec.querySelector(".flashbg")) {
                    var fb = document.createElement("i");
                    fb.className = "flashbg";
                    fb.setAttribute("aria-hidden", "true");
                    flashSec.insertBefore(fb, flashSec.firstChild);
                }
                flashSec.classList.add("flash-host");
            }
        }
        /* ---- 10 · Gust-stagger (taglist / spec-list uz enter) ---- */
        document.querySelectorAll(".taglist, .spec-list, .verb-beats").forEach(function (list) {
            for (var k = 0; k < list.children.length; k++)
                list.children[k].style.setProperty("--i", String(Math.min(k, 6)));
            list.classList.add("gustlist");
            observe(list);
        });
        // FAQ: stagger uz katru atvēršanu (re-fire)
        document.querySelectorAll(".faq-q").forEach(function (q) {
            q.addEventListener("click", function () {
                var item = q.closest(".faq-item");
                if (!item)
                    return;
                var ans = item.querySelector(".faq-a");
                if (!ans)
                    return;
                if (item.classList.contains("is-open")) {
                    var rows = ans.querySelectorAll(":scope > *");
                    rows.forEach(function (r, idx) { r.style.setProperty("--i", String(Math.min(idx, 6))); });
                    ans.classList.add("gustlist");
                    ans.classList.remove("is-in");
                    void ans.offsetWidth;
                    ans.classList.add("is-in");
                }
                else {
                    ans.classList.remove("is-in");
                }
            });
        });
        /* ---- 02 · Pressure isobars (gaišās biznesa sekcijas) ---- */
        document.querySelectorAll(".block-roi-calc, .block-stat-grid.surface-light, .block-stat-grid.surface-airy").forEach(function (sec) {
            if (sec.querySelector(".isobars-canvas"))
                return;
            sec.classList.add("isobars-host");
            var canvas = document.createElement("canvas");
            canvas.className = "isobars-canvas";
            canvas.setAttribute("aria-hidden", "true");
            sec.insertBefore(canvas, sec.firstChild);
            stageIsobars(canvas);
        });
        function stageIsobars(canvas) {
            var ctx = canvas.getContext("2d");
            var dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, t0 = performance.now(), raf = null, run = false;
            function size() {
                var r = canvas.getBoundingClientRect();
                W = r.width;
                H = r.height;
                canvas.width = Math.round(W * dpr);
                canvas.height = Math.round(H * dpr);
                ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            }
            function draw(t) {
                ctx.clearRect(0, 0, W, H);
                var lines = 16, i, x;
                for (i = 0; i < lines; i++) {
                    var f = i / (lines - 1);
                    ctx.beginPath();
                    for (x = 0; x <= W; x += 6) {
                        var u = x / W;
                        var y = H * (0.08 + f * 0.86) + Math.sin(u * 3.1 + t * 0.35 + i * 0.22) * (16 + f * 26) + Math.sin(u * 7.4 - t * 0.22 + i * 0.5) * 7;
                        x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
                    }
                    ctx.strokeStyle = "rgba(44,63,82," + (0.035 + Math.sin(f * Math.PI) * 0.05) + ")";
                    ctx.lineWidth = i % 4 === 0 ? 1.4 : 1;
                    ctx.stroke();
                }
                // Zemspiediena elipses kodols (apļi) NOŅEMTS — klienta atgriezeniskā saite.
                // Paliek tikai horizontālās kontūrlīnijas, tagad caurspīdīgākas/atturīgākas.
            }
            function tick(ts) {
                if (!run)
                    return;
                draw((ts - t0) / 1000 * (prefersReduced ? 0 : Math.max(motionVal(), .12) * 2));
                raf = requestAnimationFrame(tick);
            }
            window.addEventListener("resize", size);
            size();
            if (prefersReduced) {
                draw(3.2);
                return;
            }
            if (hasIO) {
                var io = new IntersectionObserver(function (es) {
                    es.forEach(function (e) {
                        if (e.isIntersecting) {
                            if (!run) {
                                run = true;
                                raf = requestAnimationFrame(tick);
                            }
                        }
                        else {
                            run = false;
                            if (raf)
                                cancelAnimationFrame(raf);
                        }
                    });
                }, { threshold: 0.05 });
                io.observe(canvas);
            }
            else {
                run = true;
                raf = requestAnimationFrame(tick);
            }
        }
    })();
})();
export {};
